// You'll be tempted to first try this, but this will result in runtime Javascript errors.
//import '@sentry-insurance/mdbootstrap/js/mdb.js'
// This is due to some issues in some of the module setup in mdb.js
// (see https://mdbootstrap.com/support/jquery/latest-version-of-mdb-not-compatible-with-webpack/)
// So, instead, we'll load the individual components from mdb that we actually use, which also has the
// side benefit that we drastically reduce the amount of JavaScript that needs to get bundled.
// See https://bitbucket.sentry.com/projects/COMDN/repos/dotnettemplate/browse/Sentry._MyApp_/Sentry._MyApp_.Web/src/js/mdb.ts
// for a complete list of components you can add
import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-submenu';
import 'typeahead';
import '@sentry-insurance/InternalFrontendTemplate/dist/sentry.associates.js';
import 'expose-loader?exposes=Sentry!@sentry-insurance/InternalFrontendTemplate/dist/sentry.common.js';
